import api from "../../config/client.axios.api";

export const createMachineApi = async (infoCreate: any) => {
  const response = await api.post(`/machine`, infoCreate);
  return response.data;
};
